import { render, staticRenderFns } from "./Psychologists.vue?vue&type=template&id=a610d0d8"
import script from "./Psychologists.vue?vue&type=script&lang=js"
export * from "./Psychologists.vue?vue&type=script&lang=js"
import style0 from "./Psychologists.vue?vue&type=style&index=0&id=a610d0d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports